import gql from 'graphql-tag';

const QUERY_UNIT_PRICES = gql`
  query UnitPrices($cityId: String!, $filters: FiltersInput) {
    unitPrices(cityId: $cityId, filters: $filters)
  }
`;

export const getUnitPricesQuery = client => (cityId, filters) =>
  client.query({
    query: QUERY_UNIT_PRICES,
    variables: {
      cityId,
      filters
    }
  });

export default getUnitPricesQuery;
